
import React from 'react';
import { Form } from 'antd';
import _get from 'lodash/get';
import { useFormContext } from './Form';

const FormItemWrapper = ({
  name,
  label,
  children,
  options,
  parse = v => v,
  defaultValue = '',
  formItemOptions,
  formRules = [],
}) => {
  const { getFieldDecorator, initialValues } = useFormContext();
  console.log('name', name)
  if (!name) {
    return <Form.Item label="">{children}</Form.Item>;
  }
  return (
    <Form.Item label={label} labelAlign="left" {...formItemOptions}>
      {getFieldDecorator(name, {
        ...options,
        initialValue: parse(_get(initialValues, name, defaultValue)),
        rules: formRules
      })(children)}
    </Form.Item>
  );
};

export default FormItemWrapper;
